/** POST de login: autentica con credenciales y devuelve el `LoggedUserInnerwork` con los tokens de sesión. */
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiCall } from "../apiHelper";
import { Credentials, LoggedUserInnerwork } from "@/types";

export const POSTLogin = (credentials: Credentials) =>
  apiCall<LoggedUserInnerwork>({
    method: "post",
    url: API_ENDPOINTS.LOGIN,
    data: credentials,
  });
